import { render, staticRenderFns } from "./DensityProbHistogram.vue?vue&type=template&id=d20514a6&scoped=true&"
import script from "./DensityProbHistogram.vue?vue&type=script&lang=js&"
export * from "./DensityProbHistogram.vue?vue&type=script&lang=js&"
import style0 from "./DensityProbHistogram.vue?vue&type=style&index=0&id=d20514a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20514a6",
  null
  
)

export default component.exports